import { PageShell } from "@/components/layout/PageShell";
import { PageHeader } from "@/components/ui/page-header";
import { Seo } from "@/components/seo/Seo";
import { organizationJsonLd, SITE_URL } from "@/lib/newsSeo";
import { T } from "@/i18n/T";

const About = () => (
  <PageShell>
    <Seo
      title="About Byteline"
      description="Byteline is an independent newsroom covering disruptive technology, finance and business, with daily briefings, markets data and analysis."
      path="/about"
      jsonLd={[
        organizationJsonLd,
        {
          "@context": "https://schema.org",
          "@type": "AboutPage",
          url: `${SITE_URL}/about`,
          name: "About Byteline",
        },
      ]}
    />
    <PageHeader
      eyebrow="About"
      title="About Byteline"
      description="An independent newsroom for disruptive technology, finance and business."
    />

    <div className="prose dark:prose-invert max-w-3xl">
      <p>
        Byteline tracks the technologies reshaping the economy: artificial intelligence,
        semiconductors, robotics, space, energy, biotech, policy and the markets that price
        them. We publish a daily recap, a weekly brief, live market data and coverage
        gathered from leading publications, with our own summaries and analysis on top.
      </p>

      <h2><T k="auto.what-we-publish-c716" /></h2>
      <ul>
        <li><T k="auto.daily-recap-of-the-stories-that-moved-th-d0dc" /></li>
        <li><T k="auto.weekly-brief-with-the-themes-behind-the-951f" /></li>
        <li><T k="auto.market-pages-for-crypto-assets-and-techn-2777" /></li>
        <li><T k="auto.topic-guides-explaining-recurring-subjec-abfd" /></li>
      </ul>

      <h2><T k="auto.ownership-and-funding-be43" /></h2>
      <p>
        [Placeholder: replace with your real ownership and funding statement, including the
        legal entity behind Byteline and how the site is funded.]
      </p>

      <h2><T k="auto.contact-b374" /></h2>
      <p>
        [Placeholder: replace with your real contact address for newsroom enquiries and
        corrections.]
      </p>
    </div>
  </PageShell>
);

export default About;
